import * as React from 'react';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { UploadInputWrapper } from 'client/ui/form/input/UploadInputWrapper';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { VerticalSpace } from 'client/ui/space/VerticalSpace';
import { WidgetUploadSignedInput } from './upload/WidgetUploadSignedInput';
import { WidgetInputUploadSignedText } from '../helper/WidgetInputUploadSignedText';
import { WidgetPreviewDownloader } from './upload-signed/WidgetPreviewDownloader';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Space, Button } from 'antd';
import { WidgetInputViewType } from 'common/schema/widget/input/WidgetInputViewType';
import { getWidgetInputViewType } from '../helper/getWidgetInputViewType';
import { WidgetInputFormItem } from '../view/wrapper/WidgetInputFormItem';
import { WidgetUploadInput } from './upload/WidgetUploadInput';
import { CompactSignedInput } from './upload-signed/CompactSignedInput';

export interface FormWidgetInputUploadSignedViewProps {
  widget: IWidget;
}

export function FormWidgetInputUploadSignedView(
  props: FormWidgetInputUploadSignedViewProps
) {
  const { widget } = props;

  const metadata = MetadataLogic.singleFromWidget(widget);
  const documentId = widget.input!.extra?.documentId;
  const name = `values.${metadata.id}`;

  const buttonText = widget.input!.extra?.downloadButton;

  const colProps = {
    // labelCol: { span: 6 },
    wrapperCol: { span: 18, offset: 6 },
    label: null
  };

  if (getWidgetInputViewType(widget) === WidgetInputViewType.Compact) {
    return <CompactSignedInput widget={widget} name={name} />;
  }

  return (
    <div className="widget-segned-file-wrapper">
      <FormWidgetItem name={name} widget={widget} {...colProps}>
        <UploadInputWrapper>
          <VerticalSpace size={10} />
          <WidgetInputUploadSignedText />
          <WidgetPreviewDownloader
            buttonText={buttonText}
            procedureId={widget.procedureId}
            documentId={documentId}
          />
          <VerticalSpace />
          <WidgetUploadSignedInput widget={widget} />
        </UploadInputWrapper>
      </FormWidgetItem>
    </div>
  );
}
